import React, { Component } from "react";
import FieldModal from "../../../../components/modals/fieldModal";
import InputField from "../../../../components/inputs/inputField";
import API from "../../../../utils/API";
import SelectField from '../../../../components/inputs/selectField';

class AddPrinterDeviceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            activePrinterDevices: [],
            options: [],
            selectedPrinterDevice: null,
            selectedPrinterDeviceFriendlyName: '',
            requiredFieldsFilled: false,
        }
    }

    async componentDidMount() {

        await API().get(`/getActivePrinterDevices`).then((res) => {
            if (res.data) {
                let options = res.data.activePrinterDevices.map((device) => {
                    let deviceName = device.friendlyName || 'Unnamed Device';
                    return { label: deviceName, value: device._id };
                });
                this.setState({ activePrinterDevices: res.data.activePrinterDevices, options: options });

            }
        });
    }


    addPrinterDevice = async () => {
        const { orgId, eventId, toggle, checkInAppConfiguration } = this.props;
        const payload = {
            organizationId: orgId,
            eventId: eventId,
            printerDeviceId: this.state.selectedPrinterDevice.value,
            friendlyName: this.state.selectedPrinterDeviceFriendlyName,
        };


        await API().patch(`/patchActivePrinterDevice`, payload).then((res) => {
            if (res.data) {

                let updatedActivePrinterDevices = checkInAppConfiguration.printerDevices || [];
                let updatedPrinterDevice = res.data.printerDevice;
                const existingIndex = updatedActivePrinterDevices.findIndex(device => device._id === updatedPrinterDevice._id);
                if (existingIndex !== -1) {
                    updatedActivePrinterDevices[existingIndex] = updatedPrinterDevice;
                } else {
                    updatedActivePrinterDevices.push(updatedPrinterDevice);
                }
                this.props.updatedActivePrinterDevices(updatedActivePrinterDevices);
                toggle();
            }
        });
    }



    render() {
        const { isOpen, toggle, submitting } = this.props;
        const { options, activePrinterDevices, selectedPrinterDeviceFriendlyName, selectedPrinterDevice } = this.state;


        let requiredFieldsFilled = false;
        if (selectedPrinterDevice) {
            if (selectedPrinterDevice.label == 'Unnamed Device') {
                if (selectedPrinterDeviceFriendlyName.trim() != '') {
                    requiredFieldsFilled = true;
                }
            } else {
                requiredFieldsFilled = true;
            }
        }



        return <div>
            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle={"Add Printer Device"}
                bodyHeaderText={''}
                bodyDescription={''}
                bodyContent={() => {
                    return (
                        <div>
                            <SelectField
                                label="Select Printer Device"
                                value={this.state.selectedPrinterDevice}
                                options={options}
                                onChange={(e) => {
                                    let selectedPrinterDeviceFriendlyName = '';
                                    if (e.label != 'Unnamed Device') {
                                        selectedPrinterDeviceFriendlyName = e.label;
                                    }
                                    this.setState({ selectedPrinterDevice: e, selectedPrinterDeviceFriendlyName: selectedPrinterDeviceFriendlyName });
                                }}
                            />

                            {selectedPrinterDevice && selectedPrinterDevice.label == 'Unnamed Device' &&
                                <InputField
                                    label="Friendly Name"
                                    value={selectedPrinterDeviceFriendlyName}
                                    onChange={(e) => {
                                        this.setState({ selectedPrinterDeviceFriendlyName: e.target.value });
                                    }}
                                />
                            }


                        </div>)
                }}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Add ' : 'Adding...'}
                actionButton={() => this.addPrinterDevice()}
                actionButtonDisabled={submitting || !requiredFieldsFilled}
            ></FieldModal>
        </div>
    }
}

export default AddPrinterDeviceModal;
